import React, { createContext, useContext, useEffect, useState } from 'react';
import { authApi, persistSession, getStoredUser } from '../api/auth';
import { getAccess, clearTokens } from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const bootstrap = async () => {
      if (!getAccess()) {
        setLoading(false);
        return;
      }
      try {
        const me = await authApi.me();
        setUser(me);
        localStorage.setItem('gf_user', JSON.stringify(me));
      } catch {
        clearTokens();
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    bootstrap();
  }, []);

  const login = async (email, password) => {
    const data = await authApi.login({ email, password });
    persistSession(data);
    setUser(data.user);
    return data;
  };

  const loginGoogle = async (idToken) => {
    const data = await authApi.google(idToken);
    persistSession(data);
    setUser(data.user);
    return data;
  };

  const register = (payload) => authApi.register(payload);

  const verifyEmail = async (email, code) => {
    const data = await authApi.verifyEmail({ email, code });
    persistSession(data);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    await authApi.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, login, loginGoogle, register, verifyEmail, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
};